import { useEffect, useState, useContext, useRef } from "react";
import axios from 'axios';

import { AppContext } from '../../../../context.js';

import { Button } from '../../../components/component.js';
import PatientCard from '../../../components/patientCard.js';
import Loading from '../../../components/loading.js';
import Helmet from "../../../components/helmet.js";

function UsersAssignmentOverview() {
  const context = useContext(AppContext);

  const [loading, setLoading] = useState(true);
  const [assignments, setAssignments] = useState([]);
  const [patientsModal, setPatientsModal] = useState({ visible: false, assignment: null });
  const [modalPatients, setModalPatients] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const patientsRequestIdRef = useRef(0);

  useEffect(() => {
    let u = context.addSpiner();
    axios.post('/api/admin/analytics/users/assignment-overview', {})
      .then((response) => {
        setAssignments(response.data);
        setLoading(false);
      })
      .catch((e) => {
        context.addError(e);
        context.removeSpiner(u);
      })
      .finally(() => {
        context.removeSpiner(u);
      });
  }, []);

  function openPatientsModal(assignment) {
    const requestId = ++patientsRequestIdRef.current;
    setPatientsModal({ visible: true, assignment });
    setModalPatients([]);
    setModalLoading(true);
    let u = context.addSpiner();
    axios.post('/api/admin/patients', {
      filter: { userID: [assignment.id], status: ['ACTIVE'] },
      limit: 0,
      offset: 0,
    })
      .then((response) => {
        if (requestId !== patientsRequestIdRef.current) return;
        setModalPatients(response.data.patients || []);
      })
      .catch((e) => {
        if (requestId !== patientsRequestIdRef.current) return;
        context.addError(e);
      })
      .finally(() => {
        context.removeSpiner(u);
        if (requestId !== patientsRequestIdRef.current) return;
        setModalLoading(false);
      });
  }

  function closePatientsModal() {
    patientsRequestIdRef.current += 1;
    setPatientsModal({ visible: false, assignment: null });
    setModalPatients([]);
    setModalLoading(false);
  }

  function renderModalPatients() {
    if (modalLoading) {
      return (
        <div className="typo-normal-150 text-muted">Loading...</div>
      );
    }

    if (!modalPatients || modalPatients.length === 0) {
      return (
        <div className="typo-normal-150 text-muted">No patients assigned.</div>
      );
    }

    return modalPatients.map((patient) => (
      <PatientCard key={patient.id} patient={patient} link={true} compact={true} hideCheckin={true} />
    ));
  }

  function renderAssignments() {
    if (!assignments || assignments.length === 0) {
      return (
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="typo-normal-150">No physician assignments available.</div>
          </div>
        </div>
      );
    }

    return assignments.map((assignment, index) => {
      return (
        <div key={index} className="card clickable mb-2" onClick={() => openPatientsModal(assignment)}>
          <div className="card-header sm">
            <div className="row">
              <div className="col-xs-3">
                <div className="typo-strong-175">{assignment.name}</div>
              </div>
              <div className="col-xs-6">
                <div className="typo-normal-150">{assignment.speciality || ''}</div>
              </div>
              <div className="col-xs-3 text-center">
                <div className="typo-strong-175">{assignment.total}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  if (loading) {
    return (
      <>
        <Helmet title="Analytics | Users Assignment Overview" />
        <Loading />
      </>
    );
  }

  return (
    <>
      <Helmet title="Analytics | Users Assignment Overview" />

      {patientsModal.visible && patientsModal.assignment && (
        <div className="fixed-bottom modal-bg" onClick={closePatientsModal}>
          <div className="container" style={{paddingTop: '5%'}}>
            <div className="row">
              <div className="col-xs-10 col-xs-offset-1 col-lg-6 col-lg-offset-3">
                <div className="card shadowmore" onClick={(e) => {e.stopPropagation()}}>
                  <div className="card-header sm">
                    <span className="typo-strong-300">{patientsModal.assignment.name}'s patients</span>
                  </div>
                  <div className="card-content sm max-h-[70vh] overflow-y-auto">
                    {renderModalPatients()}
                  </div>
                  <div className="card-content sm text-end">
                    <Button onClick={closePatientsModal} color="grey" text="Close" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Users Assignment Overview</div>
                <div className="typo-normal-175">Track patient assignments across all physicians. Monitor workload distribution and identify physicians with the most active patient cases</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">

            <div className="card mb-2">
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-3">
                    <div className="typo-strong-150">Physician</div>
                  </div>
                  <div className="col-xs-6">
                    <div className="typo-strong-150">Speciality</div>
                  </div>
                  <div className="col-xs-3 text-center">
                    <div className="typo-strong-150">Active Patients</div>
                  </div>
                </div>
              </div>
            </div>

            {renderAssignments()}
          </div>
        </div>
      </div>
    </>
  );
}

export default UsersAssignmentOverview;
